<template>
  <svg viewBox="0 0 24 24" fill="currentColor" stroke="none" width="22" height="22">
    <polygon points="5 3 19 12 5 21" />
  </svg>
</template>

<script>
export default {
  name: 'PlayIcon'
}
</script>
